module.exports = __webpack_public_path__ + "static/media/SDG15.53d96b3e.mp4";